import React from 'react'
import { MouseoverTooltipContent } from '../Tooltip'
import styled from 'styled-components'

interface IncentiveTooltipProps {
  children: React.ReactNode
  content: React.ReactNode
}

const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.text1};

  .campaign-card {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.bg1};
    padding: 10px;
    gap: 10px;
    color: ${({ theme }) => theme.text2};

    span {
      font-size: 14px;
      font-weight: 400;
    }

    b {
      font-weight: 600;
      color: ${({ theme }) => theme.text1};
    }

    p {
      font-size: 12px;
      font-weight: 400;
      margin: 0;
    }
  }
`

const IncentiveTooltip: React.FC<IncentiveTooltipProps> = ({ children, content }) => {
  const incentiveHeader = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      }}
    >
      <h3 style={{ margin: '0', fontSize: '16px', fontWeight: '600' }}>This pool is part of an incentive campaign</h3>
      <span style={{ fontSize: '14px', fontWeight: '400' }}>
        Provide liquidity and earn bonus tokens on top of swap fees.
      </span>
    </div>
  )

  return (
    <MouseoverTooltipContent
      style={{ padding: '0', cursor: 'default' }}
      content={
        <ContentStyled>
          {incentiveHeader}
          {content}
        </ContentStyled>
      }
    >
      {children}
    </MouseoverTooltipContent>
  )
}

export default IncentiveTooltip
